import { BOARD, CELL, pieces, position } from "./layout";

export function packingSvg(time: number): string {
  const ordered = pieces
    .map((piece) => ({ piece, p: position(piece, time) }))
    .sort((a, b) => Number(a.p.active) - Number(b.p.active));
  const body = ordered
    .map(({ piece, p }) => {
      const x = p.x,
        y = p.y - p.height * 22;
      const w = piece.w * CELL,
        h = piece.h * CELL;
      const shadow =
        p.height > 0
          ? `<rect x="${x + 5 + p.height * 18}" y="${y + 6 + p.height * 28}" width="${w}" height="${h}" rx="5" fill="#000000" opacity="${0.12 + p.height * 0.18}" filter="url(#shadow)"/>`
          : "";
      return `${shadow}<rect x="${x + 1}" y="${y + 1}" width="${w - 2}" height="${h - 2}" rx="4" fill="#B2CEC5" stroke="#718F89" stroke-width="2"/>`;
    })
    .join("");
  return `<svg xmlns="http://www.w3.org/2000/svg" width="1080" height="1920" viewBox="0 0 1080 1920"><defs><filter id="shadow" x="-30%" y="-30%" width="170%" height="170%"><feGaussianBlur stdDeviation="7"/></filter></defs><rect width="1080" height="1920" fill="#0B1020"/><rect x="${BOARD.x}" y="${BOARD.y}" width="${BOARD.size}" height="${BOARD.size}" rx="5" fill="#1B2837" stroke="#2B3A48" stroke-width="2"/>${body}<text x="540" y="1794" text-anchor="middle" font-family="Arial, sans-serif" font-size="24" letter-spacing="7" fill="#637587">LOOP NIBBLE</text></svg>`;
}
